/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Csjensblank22Inputs */

const en__field_enum_csjensblank_csjensblank22 = /** @type {(inputs: _Field_Enum_Csjensblank_Csjensblank22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Universität Darmstadt`)
};

const de__field_enum_csjensblank_csjensblank22 = /** @type {(inputs: _Field_Enum_Csjensblank_Csjensblank22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Universität Darmstadt`)
};

/**
* | output |
* | --- |
* | "Technische Universität Darmstadt" |
*
* @param {_Field_Enum_Csjensblank_Csjensblank22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_csjensblank22 = /** @type {((inputs?: _Field_Enum_Csjensblank_Csjensblank22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Csjensblank22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_csjensblank22(inputs)
	return de__field_enum_csjensblank_csjensblank22(inputs)
});
export { _field_enum_csjensblank_csjensblank22 as "_field_enum_CSJENSBLANK_CSJENSBLANK" }